import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
// import pages
import Home from './pages/Home'
import DeckPal from './pages/Deck'
import Error from './pages/Error'

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/DeckPal">
          <DeckPal />
        </Route>
        {/* <Route path="/card/:id">
          <SingleCard />
        </Route> */}
        <Route path="/*">
          <Error />
        </Route>
      </Switch>
    </Router>
  );
}

export default App
